import { Serial } from './serial'
import i18n from 'i18next'

export const sendATCommand = async (
  session: Serial,
  command: string,
  expected: string[],
): Promise<void> => {
  const verifyResponse = await session.sendCommand(command)
  for (const item of expected) {
    if (!verifyResponse.includes(item)) {
      throw new Error(
        i18n.t(
          'device.calibration.preFlightStep.certificateUploadFlow.errors.responseMissingExpected',
          { item, response: verifyResponse },
        ),
      )
    }
  }
}
